<template>
  <div v-if="loading" id="pageloader">
    <div class="loader-item">
      <img class="loading" src="/static/img/other/puff.svg" alt="page loader">
    </div>
  </div>
</template>

<script>
  export default {
    props: [
      'loading'
    ]
  }
</script>



// WEBPACK FOOTER //
// src/components/PreLoader.vue